import { Controller } from '@use-symbology-scanner/core';
import { useRef, useEffect } from 'react';

const useSymbologyScanner = (handler, config = {}) => {
  const controllerRef = useRef(null);
  useEffect(() => {
    const controller = controllerRef.current;
    if (controller) {
      controller.applyHandler(handler);
      controller.applyConfig(config);
      return controller.effect();
    }
  });
  useEffect(() => {
    const controller = new Controller(config, handler);
    controllerRef.current = controller;
    return controller.clean.bind(controller);
  }, []);
};

export { useSymbologyScanner };
